import { makeStyles, Popper } from '@material-ui/core';
import PopperJs from 'popper.js';
import React, { useEffect, useRef, useState } from 'react';
import { EditableEquipmentItem } from '../../../types';
import { MODE_FIELD } from '../constants';
import ActionButtons from './ActionsButtons';
import { EquipmentItemActionsProps } from './types';

interface Props extends EquipmentItemActionsProps<EditableEquipmentItem> {
  rootClassName?: string
  popperRef?: React.RefObject<PopperJs>
}

const useStyles = makeStyles({
  popper: {
    zIndex: 1300,
  },
});

const POPPER_MODIFIERS = {
  keepTogether: { enabled: true },
  preventOverflow: { enabled: false },
  hide: { enabled: false },
};

export const ActionsCell: React.FC<Props> = ({ popperRef, ...props }) => {
  const classes = useStyles();
  const ref = useRef<HTMLDivElement>(null);
  const [areActionsShowed, setActionsShowed] = useState(false);

  useEffect(() => {
    setActionsShowed(true);
  }, []);

  if (!props.dataItem[MODE_FIELD]) {
    return null;
  }

  return (
    <>
      <div ref={ref} className={props.rootClassName} />
      <Popper
        open={areActionsShowed}
        placement="bottom-end"
        anchorEl={ref.current}
        modifiers={POPPER_MODIFIERS}
        className={classes.popper}
      >
        <ActionButtons
          scrollBehavior="smooth"
          {...props} />
      </Popper>
    </>
  );
};
